import {forwardRef} from "react";

import 'react-device-frameset/styles/marvel-devices.min.css'
import 'react-device-frameset/styles/device-emulator.min.css'
import ScrollContainer from "react-indiana-drag-scroll";

const DraggableScrollDiv = forwardRef((props, ref) => {

    return <ScrollContainer {...props} nativeMobileScroll={true} hideScrollbars={false} horizontal={props.horizontal}>
        <div ref={ref}>
            {props.children}
        </div>
    </ScrollContainer>
});

export default DraggableScrollDiv;